// frontend/src/utils/alertas.js
import Swal from 'sweetalert2';

// Cores do seu sistema
const COLOR_PRIMARY = '#00A3E0'; // Sabesp Cyan
const COLOR_SECONDARY = '#64748b'; // Slate 500
const COLOR_DANGER = '#ef4444'; // Red

// Configuração Base (Estilo arredondado e clean)
const MySwal = Swal.mixin({
  customClass: {
    popup: 'rounded-3xl shadow-2xl font-sans',
    confirmButton: 'px-6 py-2.5 rounded-xl bg-[#00A3E0] text-white font-bold hover:bg-cyan-600 transition-all shadow-md mx-2',
    cancelButton: 'px-6 py-2.5 rounded-xl bg-gray-200 text-gray-600 font-bold hover:bg-gray-300 transition-all mx-2',
    title: 'text-gray-800 font-bold text-xl',
    htmlContainer: 'text-gray-600'
  },
  buttonsStyling: false // Desativa estilo padrão para usarmos o Tailwind acima
});

export const showSuccess = (titulo, texto) => {
  return MySwal.fire({
    icon: 'success',
    title: titulo,
    text: texto,
    confirmButtonText: 'OK, Entendi',
    timer: 3000,
    timerProgressBar: true
  });
};

export const showError = (titulo, texto) => {
  return MySwal.fire({
    icon: 'error',
    title: titulo,
    text: texto,
    confirmButtonText: 'Fechar'
  });
};

export const showWarning = (titulo, texto) => {
  return MySwal.fire({
    icon: 'warning',
    title: titulo,
    text: texto,
    confirmButtonText: 'OK'
  });
};

// Para perguntas de SIM ou NÃO
export const askConfirm = async (titulo, texto) => {
  const result = await MySwal.fire({
    icon: 'question',
    title: titulo,
    text: texto,
    showCancelButton: true,
    confirmButtonText: 'Sim, confirmar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true
  });
  return result.isConfirmed;
};